export default {
  totalInventoryNearExpiryList: [],
  totalInventoryNearExpiryCount: 0
}
